<script>
import InputLocation from '@/components/atoms/inputlib/components/InputLocation'
export default {
    name: 'Step0',
    components: { InputLocation },
    model: {
        prop: 'address',
        event: 'change',
    },
    props: {
        address: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        addressValue: {
            get() {
                return this.address
            },
            set(address) {
                this.$emit('change', { ...this.address, ...address })
                this.$emit('next')
            },
        },
    },
    methods: {
        addManually(searchHistory) {
            this.$emit('change', {
                ...{},
                ...{ phone: this.$user.model.phone },
                ...searchHistory,
            })
            this.$emit('next')
        },
    },
}
</script>

<template lang="pug">
.d-flex.flex-column.h-100
    input-location(
        v-model="addressValue" 
        @add="addManually" 
        :placeholder="$t('details.placeholder.address')" 
        required lg can-add-manually)      
</template>
